module.exports = __webpack_public_path__ + "img/img-scene-5.9b323be9.jpg";